import RelatedDetailsCell from '../../common/cell/RelatedDetailsCell';

function RelatedDetails() {
  return (
    <div>
      {[1].map((item) => (
        <RelatedDetailsCell key={item} />
      ))}
    </div>
  );
}

export default RelatedDetails;
